export default {
  position: {},
  options: {
    date: {
      position: {},
      fmt: "YYYY/MM/DD",
      style: {
        color: "#2BB7F7",
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    week: {
      position: {},
      prefix: "星期",
      style: {
        color: "#2BB7F7",
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    second: {
      position: {},
      fmt: "HH:mm:ss",
      style: {
        color: "#A6F1FE",
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
  },
}
